import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';

declare var google;
@Component({
  selector: 'adf-income-details-form',
  templateUrl: 'income_details.html',
  providers: [EnvDataService]
})
export class IncomeDetails {
  @Input() editdata: any;
  @Output() valueChange = new EventEmitter();
  @Input() dateCommenceFromEmpDetails:any;

  callMethod() {


  }

  public numberMask = createNumberMask({
    prefix: '$ ',
    allowDecimal: true,
    decimalSymbol: ".",
    decimalLimit: 2,
    suffix: ' '
  })

  incomeForm: FormGroup;
  primaryData:FormGroup;
  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  public change_log_string: any;
  public indexx : number;
  public percentage_0: any;
  public percentage_1: any;
  public percentage_2: any;
  public percentage_3: any;
  public percentage_4: any;
  public percentage_5: any;
  public date:any;
  public test:boolean=false;
  public deleteCheck:any;
  public showPrimaryApplicantEmployement: number = 1;
  public showAdditional_employement: number = -1;
  public incomeoption = [];
  public addincomeoption = [];
  public addincomefalg = [];
  public adddate = [];
  public upload_index:number = 0;
  public fileuploadstatus:boolean = true;
  public upload_user:any;
  public validation_messages = {
    'amount': [
      { type: 'required', message: 'This field is required.' }
    ],
    'frequency': [
      { type: 'required', message: 'This field is required.' }
    ],
    'date_commenced': [
      { type: 'required', message: 'This field is required.' }
    ],
    'sallary_payslip_0':[
      { type: 'required', message: 'This field is required.' }
    ]

  }

  public uploadProgress:number= 0;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public alertCtrl: AlertController,
    public SdfFormService: SdfFormService,
    private storage: AngularFireStorage,
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];

    this.incomeForm = formBuilder.group({
      itemRows: formBuilder.array([]),
      addApplicantIncomeItem: formBuilder.array([])
    });
    this.primaryData = formBuilder.group({
      firstname: ['', Validators.compose([Validators.maxLength(30), Validators.minLength(1), Validators.required])],
      middlename: ['', Validators.compose([Validators.maxLength(30)])],
      lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      addAnotherApplicantItem: this.formBuilder.array([])
    })

  }
  ngOnInit() {
  }

  primaryApplicantEmployement(event){
    debugger;
    this.showPrimaryApplicantEmployement = 1;
    this.showAdditional_employement = -1;

  }
  employementOfApplicant(event, index){
    debugger;
    this.showPrimaryApplicantEmployement = 0;
    this.showAdditional_employement = index;

  }
  employementOfApplicant2(index){
    debugger;
    this.showPrimaryApplicantEmployement = 0;
    this.showAdditional_employement = index;

  }


  addAnotherApplicant() {

    this.formApplicantIncome.push(this.initItemRowsBlank4());
    this.primaryApplicantdata.push(this.initaddAnotherApplicant2());


  }

  deleteSecondaryApplicant(index){
    this.formApplicantIncome.removeAt(index);

  }
  initItemRowsBlank4() {
    return this.formBuilder.group({
      itemRows: this.formBuilder.array([])
    });
  }
  initItemRowsBlank() {
    return this.formBuilder.group({
      itemRows: this.formBuilder.array([this.initItemRows()])
    });
  }
  initItemRowsBlank3(incomedata) {
    return this.formBuilder.group({
      itemRows: this.formBuilder.array([this.initItemRows2(incomedata)])
    });
  }
  addAnotherApplicant2(data) {
    this.formApplicantIncome.push(this.initItemRowsBlank2(data));
  }

  initItemRowsBlank2(data) {
    return this.formBuilder.group({
      itemRows: this.formBuilder.array([this.initItemRows2(data)])
    });
  }

  initItemRows() {
    return this.formBuilder.group({

      type: ['Salary', Validators.compose([Validators.required])],
      amount: [''],
      receive_overtime: [''],
      receive_commissions_bounses: [''],
      receive_moter_vehicle_allowance: [''],
      salary_sacrifice: [''],
      any_other_allowances: [''],
      frequency: ['Annual'],
      date_commenced: [this.date, Validators.compose([Validators.maxLength(30), Validators.required])],
      comments: [''],
      sallary_payslip_0: [''],
      sallary_payslip_1: [''],
      sallary_payslip_2: [''],
      sallary_payslip_3: [''],
      sallary_payslip_4: [''],
      sallary_payslip_5: [''],
      sallary_payslip_name_0: [''],
      sallary_payslip_name_1: [''],
      sallary_payslip_name_2: [''],
      sallary_payslip_name_3: [''],
      sallary_payslip_name_4: [''],
      sallary_payslip_name_5: [''],
      document_id: [''],
      deleted: [0]
    });
  }
  initItemRows_1(getDate ='') {
    return this.formBuilder.group({

      type: ['Salary', Validators.compose([Validators.required])],
      amount: [''],
      receive_overtime: [''],
      receive_commissions_bounses: [''],
      receive_moter_vehicle_allowance: [''],
      salary_sacrifice: [''],
      any_other_allowances: [''],
      frequency: ['Annual'],
      date_commenced: [getDate, Validators.compose([Validators.maxLength(30), Validators.required])],
      comments: [''],
      sallary_payslip_0: [''],
      sallary_payslip_1: [''],
      sallary_payslip_2: [''],
      sallary_payslip_3: [''],
      sallary_payslip_4: [''],
      sallary_payslip_5: [''],
      sallary_payslip_name_0: [''],
      sallary_payslip_name_1: [''],
      sallary_payslip_name_2: [''],
      sallary_payslip_name_3: [''],
      sallary_payslip_name_4: [''],
      sallary_payslip_name_5: [''],
      document_id: [''],
      deleted: [0]
    });
  }

  initItemRows2(formObj) {
    return this.formBuilder.group({

      type: [formObj.type, Validators.compose([Validators.required])],
      amount: [formObj.amount],
      receive_overtime: [formObj.receive_overtime],
      receive_commissions_bounses: [formObj.receive_commissions_bounses],
      receive_moter_vehicle_allowance: [formObj.receive_moter_vehicle_allowance],
      salary_sacrifice: [formObj.salary_sacrifice],
      any_other_allowances: [formObj.any_other_allowances],
      frequency: [formObj.frequency],
      date_commenced: [formObj.date_commenced, Validators.compose([Validators.maxLength(30), Validators.required])],
      comments: [formObj.comments],
      sallary_payslip_0: [formObj.salary[0].payslip],
      sallary_payslip_1: [formObj.salary[1].payslip],
      sallary_payslip_2: [formObj.salary[2].payslip],
      sallary_payslip_3: [formObj.salary[3].payslip],
      sallary_payslip_4: [formObj.salary[4].payslip],
      sallary_payslip_5: [formObj.salary[5].payslip],
      sallary_payslip_name_0: [formObj.salary[0].payslip_name],
      sallary_payslip_name_1: [formObj.salary[1].payslip_name],
      sallary_payslip_name_2: [formObj.salary[2].payslip_name],
      sallary_payslip_name_3: [formObj.salary[3].payslip_name],
      sallary_payslip_name_4: [formObj.salary[4].payslip_name],
      sallary_payslip_name_5: [formObj.salary[5].payslip_name],
      document_id: [formObj.document_id],
      deleted: [0]
    });
  }


  ngOnChanges() {

  }

  addIncomes() {
    this.formArr.push(this.initItemRows());
    let incomelenght = this.formArr.length - 1;
    this.incomeoption[incomelenght] = true;
    this.indexx = this.formArr.controls.length-1;
    if(this.userRole == 'contact') {
      this.formArr.controls[this.indexx]['controls'].sallary_payslip_0.setValidators(Validators.required);
      this.formArr.controls[this.indexx]['controls'].sallary_payslip_0.updateValueAndValidity();
    }

  }

  addeventIncome(event) {
    debugger;

    if(event == 'yes') {

      this.formArr.push(this.initItemRows());

      if(this.userRole == 'contact') {
        this.formArr.controls[0]['controls'].sallary_payslip_0.setValidators(Validators.required);
        this.formArr.controls[0]['controls'].sallary_payslip_0.updateValueAndValidity();
      }

      this.incomeoption[0] = false;
    }
    else {
      this.incomeoption[0] = true;
      while (this.formArr.length !== 0) {
          this.formArr.removeAt(0);
        }
    }

  }
  additioneventIncome(event) {
    debugger;
    if(event.status == 'yes') {

      console.log(this.adddate);
      //this.formArr.push(this.initItemRows());
      let index =  event.index;
      // this.adddate.forEach((dateelemt)=>{
      //   if(dateelemt.index == index) {
      //     console.log('abc');
      //     this.additionalIncome(event.index).push(this.initItemRows_1(dateelemt.getDate));
      //   }
      // })
      this.additionalIncome(event.index).push(this.initItemRows_1());

      if(this.userRole == 'contact') {
        this.additionalIncome(event.index).at(0).get('sallary_payslip_0').setValidators(Validators.required);
        this.additionalIncome(event.index).at(0).get('sallary_payslip_0').updateValueAndValidity();
      }


      this.addincomeoption[event.index] = true;
      this.addincomefalg[0] = false;
      // this.addincomeoption[[
      //   event.index
      // ]] = false;
    }
    else {
      this.addincomeoption[event.index] = true;
      this.addincomefalg[0] = true;
      while (this.additionalIncome(event.index).length !== 0) {
        this.additionalIncome(event.index).removeAt(0);
      }

    }
  }

  addAddincome(i){
    debugger;
    console.log(this.adddate);
    if(this.adddate.length > 0) {
      this.adddate.forEach((dateelemt)=>{
        if(dateelemt.index == i) {
          this.additionalIncome(i).push(this.initItemRows_1(dateelemt.getDate));
        }
      })
    }
    else {
      this.additionalIncome(i).push(this.initItemRows_1());
    }


    let adindex = this.additionalIncome(i).length - 1;
    // this.formApplicantIncome.controls[adindex]['controls']['itemRows'].controls[0].controls.sallary_payslip_0.setValidators(Validators.required);
    // this.formApplicantIncome.controls[adindex]['controls']['itemRows'].controls[0].controls.sallary_payslip_0.updateValueAndValidity();

    if(this.userRole == 'contact') {
      this.additionalIncome(i).at(adindex).get('sallary_payslip_0').setValidators(Validators.required);
      this.additionalIncome(i).at(adindex).get('sallary_payslip_0').updateValueAndValidity();
    }


    this.addincomefalg[adindex] = true;
    this.addincomeoption[i] = true;

  }

  hideShowIncomeDetials(index,incomeIndex){


    let alert = this.alertCtrl.create({
      title: 'Confirm delete Applicant',
      message: 'Are you sure you want to delete this Applicant?',
      buttons: [
          {
              text: 'No',
              handler: () => {

              }
          },
          {
              text: 'Yes',
              handler: () => {


                this.additionalIncome(index).removeAt(incomeIndex);
              }
          }
      ]
    });
    alert.present();
  }

  addIncomesAdditional(index) {
    debugger;
    this.formApplicantIncome.controls[index]['controls']['itemRows'].push(this.initItemRows());
    if(this.userRole == 'contact') {
      this.formApplicantIncome.controls[index]['controls']['itemRows'].controls[0].controls.sallary_payslip_0.setValidators(Validators.required);
      this.formApplicantIncome.controls[index]['controls']['itemRows'].controls[0].controls.sallary_payslip_0.updateValueAndValidity();
    }

  }


  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }

  get formArr() {
    return this.incomeForm.get('itemRows') as FormArray;
  }
  get formApplicantIncome() {
    return this.incomeForm.get("addApplicantIncomeItem") as FormArray;
  }



  changeLog(event, index: any) {

  }

  deleteRestoreDocument(index: number, document_id: any, type: any, collection: any, status: any, index1: number) {
    let alert = this.alertCtrl.create({
      title: 'Confirm '+status+' '+type,
      message: 'Are you sure you want to '+status+' this '+type+' ?',
      buttons: [
          {
              text: 'No',
              handler: () => {

              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  let deleted = 0;
                  if(status == 'delete'){
                    deleted = 1;
                  }
                  let postData = {
                    'document_id' : document_id,
                    'collection': collection,
                    'deleted': deleted,
                    'deleted_date' : new Date().getTime()
                  }
                  this.SdfFormService.deleteDocument(postData);
                  if(status == 'delete'){
                    if(type == 'income'){
                      if(index1 >= 0){
                        this.formApplicantIncome.controls[index]['controls'].itemRows.removeAt(index1);
                        document.getElementById('header_'+index).style.display="none";
                      }else{
                        this.formArr.removeAt(index);
                      }
                    }
                  }
                }else{
                  if(status == 'delete'){
                    if(type == 'income'){
                      if(index1 >= 0){
                        this.formApplicantIncome.controls[index]['controls'].itemRows.removeAt(index1);
                        document.getElementById('header_'+index).style.display="none";
                      }else{
                        this.formArr.removeAt(index);
                      }
                    }
                  }
                }
              }
          }
      ]
    });
    alert.present();
  }

  SaveImageRef(filePath, file) {
    return {
      task: this.storage.upload(filePath, file),
      ref: this.storage.ref(filePath)
    };
  }

  uploadImage(event, uid, i, i1) {

    console.log(i);
    console.log(i1);
    this.upload_index=i;
    this.upload_user = i1;
    debugger;
    const thiss = this;
    //uid = this.SDF_form_document_id;
    if (event.target.files.length > 0) {
      Object.keys(event.target.files).forEach(function(key) {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[key]);
        reader.onload = (e:any) => {
          const fileraw = event.target.files[key]; //payslip_sallary /sallary_payslip/undefined
          // const filePath = '/sallary_payslip/' + uid + '/' + (Math.floor(1000 + Math.random() * 9000) + 1);
          const filePath = '/sallary_payslip/undefined/' + (Math.floor(1000 + Math.random() * 9000) + 1);

          const result = thiss.SaveImageRef(filePath, fileraw);

          result.task.percentageChanges().subscribe(
            (value: number) => {
              thiss.uploadProgress = value
              thiss.fileuploadstatus = false;
            },
          );

          const ref = result.ref;
          if(key == '0'){
            thiss.percentage_0 = result.task.percentageChanges();
          }else if(key == '1'){
            thiss.percentage_1 = result.task.percentageChanges();
          }else if(key == '2'){
            thiss.percentage_2 = result.task.percentageChanges();
          }else if(key == '3'){
            thiss.percentage_3 = result.task.percentageChanges();
          }else if(key == '4'){
            thiss.percentage_4 = result.task.percentageChanges();
          }else if(key == '5'){
            thiss.percentage_5 = result.task.percentageChanges();
          }

          result.task.then(a => {
            ref.getDownloadURL().subscribe(a => {
              thiss.fileuploadstatus = true;

              if(i1 >= 0){
                if(key == '0'){
                  if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_0').value != ''){
                    if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_1').value != ''){
                      if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_2').value != ''){
                        if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != ''){
                          if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != ''){
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                          }else{
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                            thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                          }
                        }else{
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                        }
                      }else{
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_2.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_2.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_1.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_1.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_0.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_0.setValue(event.target.files[key].name);
                  }
                }else if(key == '1'){
                  if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_1').value != ''){
                    if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_2').value != ''){
                      if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != ''){
                        if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != ''){
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                        }else{
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                          thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                        }
                      }else{
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_2.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_2.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_1.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_1.setValue(event.target.files[key].name);
                  }
                }else if(key == '2'){
                  if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_2').value != ''){
                    if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != ''){
                      if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != ''){
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                      }else{
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                        thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_2.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_2.setValue(event.target.files[key].name);
                  }
                }else if(key == '3'){
                  if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_3').value != ''){
                    if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != ''){
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                    }else{
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                      thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_3.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_3.setValue(event.target.files[key].name);
                  }
                }else if(key == '4'){
                  if(thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].get('sallary_payslip_4').value != ''){
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                  }else{
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_4.setValue(a);
                    thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_4.setValue(event.target.files[key].name);
                  }
                }else if(key == '5'){
                  thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_5.setValue(a);
                  thiss.formApplicantIncome.controls[i]['controls'].itemRows.controls[i1].controls.sallary_payslip_name_5.setValue(event.target.files[key].name);
                }

              }else{
                if(key == '0'){
                  if(thiss.formArr.controls[i].get('sallary_payslip_0').value != ''){
                    if(thiss.formArr.controls[i].get('sallary_payslip_1').value != ''){
                      if(thiss.formArr.controls[i].get('sallary_payslip_2').value != ''){
                        if(thiss.formArr.controls[i].get('sallary_payslip_3').value != ''){
                          if(thiss.formArr.controls[i].get('sallary_payslip_4').value != ''){
                            thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                            thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                          }else{
                            thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                            thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                          }
                        }else{
                          thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                          thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                        }
                      }else{
                        thiss.formArr.controls[i]['controls'].sallary_payslip_2.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formArr.controls[i]['controls'].sallary_payslip_1.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_1.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formArr.controls[i]['controls'].sallary_payslip_0.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_0.setValue(event.target.files[key].name);
                  }
                }else if(key == '1'){
                  if(thiss.formArr.controls[i].get('sallary_payslip_1').value != ''){
                    if(thiss.formArr.controls[i].get('sallary_payslip_2').value != ''){
                      if(thiss.formArr.controls[i].get('sallary_payslip_3').value != ''){
                        if(thiss.formArr.controls[i].get('sallary_payslip_4').value != ''){
                          thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                          thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                        }else{
                          thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                          thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                        }
                      }else{
                        thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formArr.controls[i]['controls'].sallary_payslip_2.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formArr.controls[i]['controls'].sallary_payslip_1.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_1.setValue(event.target.files[key].name);
                  }
                }else if(key == '2'){
                  if(thiss.formArr.controls[i].get('sallary_payslip_2').value != ''){
                    if(thiss.formArr.controls[i].get('sallary_payslip_3').value != ''){
                      if(thiss.formArr.controls[i].get('sallary_payslip_4').value != ''){
                        thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                      }else{
                        thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                        thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                      }
                    }else{
                      thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formArr.controls[i]['controls'].sallary_payslip_2.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue(event.target.files[key].name);
                  }
                }else if(key == '3'){
                  if(thiss.formArr.controls[i].get('sallary_payslip_3').value != ''){
                    if(thiss.formArr.controls[i].get('sallary_payslip_4').value != ''){
                      thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                    }else{
                      thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                      thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                    }
                  }else{
                    thiss.formArr.controls[i]['controls'].sallary_payslip_3.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue(event.target.files[key].name);
                  }
                }else if(key == '4'){
                  if(thiss.formArr.controls[i].get('sallary_payslip_4').value != ''){
                    thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                  }else{
                    thiss.formArr.controls[i]['controls'].sallary_payslip_4.setValue(a);
                    thiss.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue(event.target.files[key].name);
                  }
                }else if(key == '5'){
                  thiss.formArr.controls[i]['controls'].sallary_payslip_5.setValue(a);
                  thiss.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue(event.target.files[key].name);
                }
              }

            });
          });
        }, error => {

        }
      });
    }
  }


  getValue() {
    this.valueChange.emit({incomeDetailFormValue:this.incomeForm.value,
      incomeDetailFormIsValid:true,incomedetailsform:this.incomeForm});
  }

  populateDataForEdit(data,adfdata)
  {
   debugger;
    this.SDF_form_document_id = adfdata.adf_form_id;
    let primary_incomedetail:any=[];
    let additional_incomedetails:any=[];
    if(data.length > 0){

      data.forEach((dataelement,index) => {
        if(dataelement.type == 'primary'){
          if(dataelement.contact_details.employment_details) {
            let uData = dataelement.contact_details.employment_details;
            var getDate = uData.start_date;
            if(getDate) {
              this.date = getDate;
            }

            if(dataelement.contact_details.employment_details.incomes) {
              dataelement.contact_details.employment_details.incomes.forEach(element=>{

                if(uData.date_commenced == '') {
                  element.date_commenced=this.date;
                }

                primary_incomedetail.push(element);
              })
              if(dataelement.contact_details.employment_details.incomes.length == 0) {
                this.addIncomes();

                // this.formArr.controls[index]['controls'].sallary_payslip_0.setValidators(Validators.required);
                // this.formArr.controls[index]['controls'].sallary_payslip_0.updateValueAndValidity();

              }
            }
            else {
               this.addIncomes();

              //  this.formArr.controls[index]['controls'].sallary_payslip_0.setValidators(Validators.required);
              //  this.formArr.controls[index]['controls'].sallary_payslip_0.updateValueAndValidity();
            }
          }

        }
        else{
          let add_user = dataelement.user_data;

          this.formApplicantIncome.push(this.initItemRowsBlank4());
          additional_incomedetails.push(dataelement);
          // dataelement.contact_details.employment_details.incomes.forEach((element,adindex)=>{
          //   console.log('xcb');
          //   this.addincomeoption[index] = true;
          //   this.addincomefalg[adindex] = true;
          //     this.additionalIncome(index).push(this.initItemRows2(element));
          //   //this.formApplicantIncome.at(index).get().push(this.initItemRowsBlank3(element));
          //   //this.formApplicantIncome.controls[index]['controls']['itemRows'].push(this.initItemRows2(element));
          // })

        }

      });

  }

  if(primary_incomedetail.length > 0)
  {
    primary_incomedetail.forEach((element,index)=>{
       this.incomeoption[index] = true;
      this.formArr.push(this.initItemRows2(element));
      if(element.type == 'Salary') {

        if(this.userRole == 'contact') {
          this.formArr.controls[index]['controls'].sallary_payslip_0.setValidators(Validators.required);
          this.formArr.controls[index]['controls'].sallary_payslip_0.updateValueAndValidity();
        }

      }
    })
  }
  console.log(this.incomeForm);
  console.log(this.primaryData);
  console.log(this.formApplicantIncome);
  additional_incomedetails.forEach((newdataelement,index) => {
    console.log('new sd');
    if(newdataelement.contact_details.employment_details) {
      console.log(newdataelement.contact_details.employment_details);
        if(newdataelement.contact_details.employment_details.currentlyEmployment !== 'no') {
            let dateelemt = {
              index:index,
              getDate:newdataelement.contact_details.employment_details.start_date
            }
            this.adddate.push(dateelemt);
        }

        if(newdataelement.contact_details.employment_details.incomes) {
          newdataelement.contact_details.employment_details.incomes.forEach((element,adindex)=>{
            console.log('xcb');
            this.addincomeoption[index] = true;
            this.addincomefalg[adindex] = true;

                if(element.date_commenced == '') {
                  element.date_commenced = newdataelement.contact_details.employment_details.start_date;
                }

              this.additionalIncome(index).push(this.initItemRows2(element));

              if(element.type == 'Salary') {
                  if(this.userRole == 'contact') {
                    this.formApplicantIncome.controls[index]['controls']['itemRows'].controls[0].controls.sallary_payslip_0.setValidators(Validators.required);
                    this.formApplicantIncome.controls[index]['controls']['itemRows'].controls[0].controls.sallary_payslip_0.updateValueAndValidity();
                  }

              }
            //this.formApplicantIncome.at(index).get().push(this.initItemRowsBlank3(element));
            //this.formApplicantIncome.controls[index]['controls']['itemRows'].push(this.initItemRows2(element));
          })

          if(newdataelement.contact_details.employment_details.incomes.length == 0) {
            this.addIncomesAdditional(index);

            // this.formApplicantIncome.controls[index]['controls']['itemRows'].controls[0].controls.sallary_payslip_0.setValidators(Validators.required);
            // this.formApplicantIncome.controls[index]['controls']['itemRows'].controls[0].controls.sallary_payslip_0.updateValueAndValidity();
          }

        }
        else {

           this.addIncomesAdditional(index);

          //  this.formApplicantIncome.controls[index]['controls']['itemRows'].controls[0].controls.sallary_payslip_0.setValidators(Validators.required);
          //  this.formApplicantIncome.controls[index]['controls']['itemRows'].controls[0].controls.sallary_payslip_0.updateValueAndValidity();

        }

    }
    else {
      //this.formApplicantIncome.push(this.initItemRowsBlank4());
    }

  })

  console.log(this.incomeForm);
  console.log(this.primaryData);
  debugger;

  }
  additionalApplicantIncome(): FormArray {
    return this.incomeForm.get('addApplicantIncomeItem') as FormArray;
  }

  additionalIncome(appIndex: number): FormArray {
    return this.additionalApplicantIncome().at(appIndex).get("itemRows") as FormArray
  }

  getRoleStartDate(date){

    debugger;
    let primaryincomelenght = this.formArr.length;
    if(primaryincomelenght > 0) {
      console.log(this.date);
      let getdate = this.formArr.at(0).get('date_commenced').value;
      if(getdate == '' || getdate == undefined || getdate == null) {
        this.formArr.at(0).get('date_commenced').setValue(date);
      }

    }

    this.date = date;


  }
  AddincomeDateChange(event) {
    console.log(event);
    debugger;
     if(this.adddate.length > 0) {
       let checkflag = 0;
        this.adddate.forEach(dateelement => {
              if(dateelement.index == event.index) {
                checkflag = 1;
                dateelement.getDate = event.getDate;
              }
        });
        if(checkflag == 0) {
          this.adddate.push(event);
        }
     }
     else {
        this.adddate.push(event);
     }


    console.log(this.additionalIncome(event.index));
    let getdata = this.additionalIncome(event.index).at(0).get('date_commenced').value;
     if(getdata == '') {
        this.additionalIncome(event.index).at(0).get('date_commenced').setValue(event.getDate);
     }

  }

  getDateCommence(obj){




  }
  initaddAnotherApplicant3(user) {

    return this.formBuilder.group({

      secondary_firstname: [user.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: ['', Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [user.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [user.email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [user.mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [user.uid],
      document_id: ['']
    });
  }
  initaddAnotherApplicant2() {

    return this.formBuilder.group({

      secondary_firstname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: ['', Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: ['', Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }
  initaddAnotherApplicant(adfobj) {

    return this.formBuilder.group({

      secondary_firstname: [adfobj.secondary_firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [adfobj.secondary_middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [adfobj.secondary_lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [adfobj.secondary_email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [adfobj.secondary_mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [adfobj.secondary_date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }
  initaddAnotherApplicant_new(adfobj) {

    return this.formBuilder.group({

      secondary_firstname: [adfobj.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [adfobj.middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [adfobj.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [adfobj.email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [adfobj.mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [adfobj.date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [adfobj.uid],
      document_id: ['']
    });
  }
  get primaryApplicantdata() {
    return this.primaryData.get('addAnotherApplicantItem') as FormArray;
  }
  setIncomeDetails(primaryDetails) {

    this.primaryData.controls.firstname.setValue(primaryDetails.value.firstname);
    this.primaryData.controls.lastname.setValue(primaryDetails.value.lastname);
    primaryDetails.value.addAnotherApplicantItem.forEach((element,index) => {
      if(this.primaryApplicantdata.value[index]) {
        this.primaryApplicantdata.value[index].secondary_firstname = element.secondary_firstname;
        this.primaryApplicantdata.value[index].secondary_lastname = element.secondary_lastname;
        }
        else {
          this.primaryApplicantdata.push(this.initaddAnotherApplicant(element));
        }
    });



  }
  setAddiIncomeDetails(additionalDetail) {


    while ((<FormArray>(<FormArray>this.incomeForm.get('addApplicantIncomeItem')).at(additionalDetail.additional_index).get('itemRows')).length !== 0) {
      (<FormArray>(<FormArray>this.incomeForm.get('addApplicantIncomeItem')).at(additionalDetail.additional_index).get('itemRows')).removeAt(0);
    }

    console.log(this.primaryApplicantdata.at(additionalDetail.additional_index));
    debugger;
    this.primaryApplicantdata.at(additionalDetail.additional_index).get('secondary_firstname').setValue(additionalDetail.user_data.firstname);
    this.primaryApplicantdata.at(additionalDetail.additional_index).get('secondary_lastname').setValue(additionalDetail.user_data.lastname);
    debugger;

    let dateelemt = {
      index:additionalDetail.additional_index,
      getDate:additionalDetail.contact_details.employment_details.start_date
    }

 this.adddate.push(dateelemt);

    console.log(this.additionalIncome(additionalDetail.additional_index));

    if(additionalDetail.contact_details.employment_details.incomes.length > 0) {

      additionalDetail.contact_details.employment_details.incomes.forEach(element=>{

        this.addincomeoption[additionalDetail.additional_index] = true;
        this.addincomefalg[additionalDetail.additional_index] = true;

            if(element.date_commenced == '') {
              element.date_commenced = additionalDetail.contact_details.employment_details.start_date;
            }

        this.additionalIncome(additionalDetail.additional_index).push(this.initItemRows2(element));
        //this.additionalIncome(additionalDetail.additional_index).push(this.initItemRowsBlank3(element));
      })

    }
    console.log(this.incomeForm);

  }
  getUserData(e) {
    console.log(e);
    while ((<FormArray>this.incomeForm.get('itemRows')).length !== 0) {
      (<FormArray>this.incomeForm.get('itemRows')).removeAt(0);
    }

    let uData = e.contact_details.employment_details;
    if(uData) {
      var getDate = uData.start_date;
      if(getDate) {
        this.date = getDate;
      }

      let income_details = e.contact_details.employment_details.incomes;
      income_details.forEach((incomeelement,index) => {

        if(incomeelement.date_commenced == '') {
          incomeelement.date_commenced=this.date;
        }
        this.formArr.push(this.initItemRows2(incomeelement));

      });
    }


    let add_user = e.user_data;


    this.primaryData.controls.firstname.setValue(add_user.firstname);
    this.primaryData.controls.lastname.setValue(add_user.lastname);

  }


  payslip_remove(postion, i, status) {
    let alert = this.alertCtrl.create({
      title: 'Confirm remove payslip',
      message: 'Are you sure you want to remove this payslip ?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            if (status == "main") {
              if (postion == 0) {
                this.formArr.controls[i]['controls'].sallary_payslip_0.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_0.setValue("");
              } else if (postion == 1) {
                this.formArr.controls[i]['controls'].sallary_payslip_1.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_1.setValue("");
              } else if (postion == 2) {
                this.formArr.controls[i]['controls'].sallary_payslip_2.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_2.setValue("");
              } else if (postion == 3) {
                this.formArr.controls[i]['controls'].sallary_payslip_3.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_3.setValue("");
              } else if (postion == 4) {
                this.formArr.controls[i]['controls'].sallary_payslip_4.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_4.setValue("");
              } else if (postion == 5) {
                this.formArr.controls[i]['controls'].sallary_payslip_5.setValue("");
                this.formArr.controls[i]['controls'].sallary_payslip_name_5.setValue("");
              }
              // const docRef = firebase.firestore().collection('/SDF_income');
              // if (this.formArr.controls[i].get('document_id').value == '' || this.formArr.controls[i].get('document_id').value == null || this.formArr.controls[i].get('document_id').value == undefined) { } else {
              //   if (postion == 0) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_0: ''
              //     });
              //   } else if (postion == 1) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_1: ''
              //     });
              //   } else if (postion == 2) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_2: ''
              //     });
              //   } else if (postion == 3) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_3: ''
              //     });
              //   } else if (postion == 4) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_4: ''
              //     });
              //   } else if (postion == 5) {
              //     docRef.doc(this.formArr.controls[i].get('document_id').value).update({
              //       sallary_payslip_5: ''
              //     });
              //   }
              // }
            } else if (status >= 0) {
              if (postion == 0) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_0.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_0.setValue("");
              } else if (postion == 1) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_1.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_1.setValue("");
              } else if (postion == 2) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_2.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_2.setValue("");
              } else if (postion == 3) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_3.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_3.setValue("");
              } else if (postion == 4) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_4.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_4.setValue("");
              } else if (postion == 5) {
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_5.setValue("");
                this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].controls.sallary_payslip_name_5.setValue("");
              }
              // const docRef = firebase.firestore().collection('/SDF_income');
              // if (this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value == '' || this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value == null || this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value == undefined) { } else {
              //   if (postion == 0) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_0: ''
              //     });
              //   } else if (postion == 1) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_1: ''
              //     });
              //   } else if (postion == 2) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_2: ''
              //     });
              //   } else if (postion == 3) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_3: ''
              //     });
              //   } else if (postion == 4) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_4: ''
              //     });
              //   } else if (postion == 5) {
              //     docRef.doc(this.formApplicantIncome.controls[i]['controls'].itemRows.controls[status].get('document_id').value).update({
              //       sallary_payslip_5: ''
              //     });
              //   }
              // }
            }
          }
        }
      ]
    });
    alert.present();
  }

  setAdditionalDetails(data){
     console.log(data);
     debugger;
      data.forEach((element,index) => {
          if(element.type == "additional") {

              if(this.primaryApplicantdata.value[index]) {
              this.primaryApplicantdata.value[index].secondary_firstname = element.user_data.firstname;
              this.primaryApplicantdata.value[index].secondary_lastname = element.user_data.lastname;
              }
              else {
                this.primaryApplicantdata.push(this.initaddAnotherApplicant_new(element.user_data));
              }
          }
          else {
            this.primaryData.controls.firstname.setValue(element.user_data.firstname);
            this.primaryData.controls.lastname.setValue(element.user_data.lastname);
          }

      });
    }

    public changeType($event, type, i, i1) {
      console.log($event + type + i + i1)
      debugger;
      console.log(this.incomeForm);
      if($event.target.value == 'Salary'){
        if(i1 == 'main'){

          if(this.userRole == 'contact') {
            this.formArr.controls[i]['controls'].sallary_payslip_0.setValidators(Validators.required);
            this.formArr.controls[i]['controls'].sallary_payslip_0.updateValueAndValidity();
          }

            //  this.formArr.at(i).get('sallary_payslip_0').setValidators(Validators.required);
            //  this.formArr.at(i).get('sallary_payslip_0').updateValueAndValidity();
        }else{

          if(this.userRole == 'contact') {
            this.formApplicantIncome.controls[i]['controls']['itemRows'].controls[i1].controls.sallary_payslip_0.setValidators(Validators.required);
            this.formApplicantIncome.controls[i]['controls']['itemRows'].controls[i1].controls.sallary_payslip_0.updateValueAndValidity();

          }


        }

      }else{
        if(i1 == 'main'){
          if(this.userRole == 'contact') {
            this.formArr.controls[i]['controls'].sallary_payslip_0.clearValidators();
            this.formArr.controls[i]['controls'].sallary_payslip_0.updateValueAndValidity();
          }

        }else{

          if(this.userRole == 'contact') {
            this.formApplicantIncome.controls[i]['controls']['itemRows'].controls[i1].controls.sallary_payslip_0.clearValidators();
            this.formApplicantIncome.controls[i]['controls']['itemRows'].controls[i1].controls.sallary_payslip_0.updateValueAndValidity();
          }

        }

      }



    }


}




// WEBPACK FOOTER //
// ./src/pages/adf-page/component/employment-and-incomedetails/income-details/income_details.ts